import { Transition } from "@headlessui/react"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import Tooltip from "src/components/Tooltip"

const CollapsibleSection = ({
  title,
  tooltip = false,
  children,
  forceOpen = false,
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (forceOpen) setOpen(true)
  }, [forceOpen])

  const handleContainerClick = (_event) => {
    setOpen(!open)
  }

  const handleChildClick = (event) => {
    event.stopPropagation()
  }

  return (
    <div
      className="border-t border-gray-300 py-8"
      onClick={handleContainerClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <h2 className="m-0 text-xl font-semibold text-gray-900">{title}</h2>
          {tooltip ? (
            <Tooltip text={tooltip} placement="right">
              <i className="fa-solid fa-circle-info m-1 cursor-pointer text-gray-600" />
            </Tooltip>
          ) : null}
        </div>
        <div className="cursor-pointer">
          {open ? (
            <i className="fa-solid fa-caret-down text-2xl" />
          ) : (
            <i className="fa-solid fa-caret-right text-2xl" />
          )}
        </div>
      </div>
      <Transition
        show={open}
        unmount={false}
        enter="transition-opacity duration-500"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div onClick={handleChildClick} className="mt-8">
          {children}
        </div>
      </Transition>
    </div>
  )
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  children: PropTypes.node.isRequired,
  forceOpen: PropTypes.bool,
}

export default CollapsibleSection
